import { Directive, ElementRef, HOST_TAG_NAME, booleanAttribute, inject, input, model } from '@angular/core';

@Directive({
    standalone: true,
    host: {
        '[attr.disabled]': '_anchorButton ? null : (disabled() ? "" : null)',
        '[attr.aria-disabled]': 'disabled() ? true : null',
        '[class.ds-btn-inverse]': 'inverse()',
        '[attr.tabindex]': 'disabled() ? -1 : 0',
        '(keydown)': 'onKeydown($event)',
    },
})
export abstract class DsButtonBase {
    public readonly _elementRef = inject(ElementRef);

    public readonly disabled = input(false, { transform: booleanAttribute });
    public readonly inverse = model(false);

    private readonly tagName = inject(HOST_TAG_NAME);
    private readonly _anchorButton = this.tagName === 'a';

    onKeydown(event: KeyboardEvent) {
        const { key } = event;
        if ((key === ' ' || key === 'Enter') && this._anchorButton) {
            event.preventDefault();
            (this._elementRef as ElementRef<HTMLAnchorElement>).nativeElement.click();
        }
    }
}
